<template>
  <footer class="py-4 bg-[#114c3e]">
    <div class="container mx-auto px-4 text-xs md:text-sm ">
      <p class="text-center text-white">Feria Internacional del Mueble Argentino</p>
      <p class="text-center text-white">© 2026 Todos los derechos reservados</p>
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
    methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>